var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopDecreasingMoversByVolume({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E3A5D23F-1ACD-4706-986F-4E8B1BAF3730") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-39.000000, -1131.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-2",
    transform: "translate(39.000000, 1131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-Mask"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EEEEEE",
    x: 0,
    y: 75,
    width: 235,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#EEEEEE",
    x: 0,
    y: 24,
    width: 235,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L233,0 C234.104569,-2.02906125e-16 235,0.8954305 235,2 L235,25 L235,25 L0,25 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 34,
    width: 25,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 84,
    width: 43,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 34,
    width: 36,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 84,
    width: 27,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 34,
    width: 17,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 84,
    width: 18,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#242C33",
    x: 8,
    y: 8,
    width: 41,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#242C33",
    x: 87,
    y: 8,
    width: 43,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#242C33",
    x: 168,
    y: 8,
    width: 27,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 50,
    width: 235,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,100 L235,100 L235,123 C235,124.104569 234.104569,125 233,125 L2,125 C0.8954305,125 1.3527075e-16,124.104569 0,123 L0,100 L0,100 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 59,
    width: 37,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 8,
    y: 109,
    width: 34,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 59,
    width: 36,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 87,
    y: 109,
    width: 48,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 59,
    width: 21,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 168,
    y: 109,
    width: 21,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 82,
    y: 0,
    width: 1,
    height: 125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 161,
    y: 0,
    width: 1,
    height: 125
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 202.05,
    y: 41,
    width: 22.95,
    height: 51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.525,45.7906331 L218.934367,51.2 L218.032099,52.1022683 L213.999633,48.0686331 L214,89 L213,89 L212.999633,48.1186331 L209.017194,52.1015611 L208.115633,51.2 L213.525,45.7906331 Z M213.525,47.5937554 L213.118633,47.9996331 L213.930633,47.9996331 L213.525,47.5937554 Z",
    id: "Combined-Shape",
    fill: "#FFC000",
    transform: "translate(213.525000, 67.395317) rotate(-180.000000) translate(-213.525000, -67.395317) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDecreasingMoversByVolume);
export default __webpack_public_path__ + "static/media/top-decreasing-movers-by-volume.dd3fb777ddd719fe2b5853be8170d4df.svg";
export { ForwardRef as ReactComponent };